import { cn } from '@forest/shared'
import { mergeProps, Show } from 'solid-js'
import { m } from '~/paraglide/messages'
import { BellIcon } from './icons/bell'
import { StarIcon } from './icons/star'
import { UnlockIcon } from './icons/unlock'

export function ReminderSection(props: {
  class?: string
  barClass?: string
  hasDescription?: boolean
}) {
  const mergedProps = mergeProps({ hasDescription: false }, props)
  return (
    <div
      class={cn('relative flex flex-col gap-8 px-6 text-white', props.class)}
    >
      <DecoBar
        class={cn(
          'pointer-events-none absolute left-[41px] top-4',
          props.barClass,
        )}
      />

      <Show when={mergedProps.hasDescription}>
        <p>{m.how_trial_works_title()}</p>
      </Show>

      <div class="relative flex gap-[10px] pl-[6px]">
        <div class="size-[30px] shrink-0">
          <UnlockIcon />
        </div>
        <div class="flex-1 space-y-1">
          <h2 class="font-bold">{m.subscription_walkthrough_p3_today()}</h2>
          <p class="text-sm">{m.subscription_walkthrough_p3_today_note()}</p>
        </div>
      </div>
      <div class="relative flex gap-[10px] pl-[6px]">
        <div class="size-[30px] shrink-0">
          <BellIcon />
        </div>
        <div class="flex-1 space-y-1">
          <h2 class="font-bold">
            {m.subscription_walkthrough_p3_1_day_before_trail()}
          </h2>
          <p class="text-sm">
            {m.subscription_walkthrough_p3_1_day_before_trail_note()}
          </p>
        </div>
      </div>
      <div class="relative flex gap-[10px] pl-[6px]">
        <div class="size-[30px] shrink-0">
          <StarIcon />
        </div>
        <div class="flex-1 space-y-1">
          <h2 class="font-bold">{m.subscription_walkthrough_p3_trail_end()}</h2>
          <p class="text-sm">
            {m.subscription_walkthrough_p3_trail_end_note()}
          </p>
        </div>
      </div>
    </div>
  )
}

function DecoBar(props: { class?: string }) {
  return (
    <div
      class={cn('h-[319px] w-2', props.class)}
      style={{
        'background-image':
          'linear-gradient(180deg, #81D200 -14.68%, #0EBC73 26.07%, rgba(8, 193, 243, 0.66) 59.8%, rgba(8, 193, 243, 0.00) 82.71%)',
      }}
    />
  )
}
